import type { TossCheckoutPendingPayload } from '@/types/api/payment';

const KEY = 'medicrew_toss_checkout_pending';

export function saveTossCheckoutPending(payload: TossCheckoutPendingPayload): void {
    try {
        sessionStorage.setItem(KEY, JSON.stringify(payload));
    } catch {
        /* storage full 등 */
    }
}

export function readTossCheckoutPending(): TossCheckoutPendingPayload | null {
    try {
        const raw = sessionStorage.getItem(KEY);
        if (!raw) return null;
        const o = JSON.parse(raw) as TossCheckoutPendingPayload;
        if (
            typeof o.medicrewOrderId === 'number' &&
            typeof o.tossMerchantOrderId === 'string' &&
            typeof o.amount === 'number' &&
            Array.isArray(o.selectedClassIds)
        ) {
            return {
                ...o,
                redirectBase: o.redirectBase === 'master' ? 'master' : 'student',
            };
        }
        return null;
    } catch {
        return null;
    }
}

export function clearTossCheckoutPending(): void {
    try {
        sessionStorage.removeItem(KEY);
    } catch {
        /* ignore */
    }
}
